import React from 'react';

const RolePermissionContext = React.createContext(null);

export default RolePermissionContext;
